const origin = window.location.origin + '/';

export function serverImage(route: string) {
    return `${origin}img/${route}`;
}

export function img(route: string) {
    return `${process.env.BASE_THEME_PATH}/img/${route}`;
}

export function imgUrl(route: string) {
    return `url(${process.env.BASE_THEME_PATH}/img/${route})`;
}

export function uploadsImg(route: string) {
    return `${origin}wp-content/uploads/${route}`;
}
export function uploadsImgUrl(route: string) {
    return `url(${origin}wp-content/uploads/${route})`;
}
